module.exports = require("core-js-pure/stable/instance/starts-with");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs3/core-js-stable/instance/starts-with.js
// module id = 601
// module chunks = 0